__turbopack_context__.v({
  "parallax": "FloatingPowerup-module__7SySHW__parallax",
});
